import { Pipe } from '@angular/core';
var IsIdenticalToPipe = (function () {
    function IsIdenticalToPipe() {
    }
    IsIdenticalToPipe.prototype.transform = function (input, other) {
        return input === other;
    };
    IsIdenticalToPipe.decorators = [
        { type: Pipe, args: [{ name: 'isIdenticalTo' },] },
    ];
    /** @nocollapse */
    IsIdenticalToPipe.ctorParameters = function () { return []; };
    return IsIdenticalToPipe;
}());
export { IsIdenticalToPipe };
//# sourceMappingURL=is-identical-to.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/boolean/is-identical-to.js
// module id = 246
// module chunks = 4